<template>
  <v-container>
    <div
      style="max-width: 300px"
      class="text-center mx-auto"
    >
      <v-img
        src="/logos/vilke_horizontal_transparent_pink.png"
        min-height="33px"
        max-width="48px"
        class="mx-auto mt-6"
      />

      <h1
        class="mt-12 display-2 font-weight-bold"
      >
        Päivitys käynnissä.
      </h1>

      <p
        class="mb-0 mt-12 blue-grey--text font-weight-bold"
      >
        Valmistelemme jotain jännittävää. Tsekkaa uudestaan
        vaikka 10 minuutin kuluttua. Tuut niin tykkää tästä.
        <br>
        <br>
        T. Ylläpito 💕
      </p>

      <v-img
        src="img/maintenance.svg"
        max-width="300px"
        class="mx-auto mt-12"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      maintenance: 'app/maintenance',
    }),
  },

  mounted() {
    if (!this.maintenance) {
      this.$router.replace({
        name: 'posts',
        params: {
          gender: 'kaikki',
          orderBy: 'uudet',
        },
      });
    }
  },
};
</script>
